import React from 'react'
import {FU} from '../../../../types';
import st from './SidebarContentContainer.module.scss'

export const SidebarContentContainer: FU = ({children}) => (
    <div className={st.container}>
        {children}
    </div>
)